import bowser from "bowser";

import {
  MIN_SUPPORTED_BROWSERS,
  HTML5_COPY_SUPPORTED_BROWSERS,
  DEPRECATED_BROWSERS
} from "../constants/Env";
import * as types from "../constants/ActionTypes";
import {
  getProceedUnsupportedBrowser,
  getNextDeprecatedWarningDate
} from "../storage/localStorage";
import { getBreakpoint } from "../components/ResponsiveBlock";

//https://www.npmjs.com/package/bowser/v/1.9.4#bowserisunsupportedbrowserminversions-object--strictmode-boolean--ua-string--boolean
const isDeprecatedBrowser = bowser.isUnsupportedBrowser(
  DEPRECATED_BROWSERS,
  window.navigator.userAgent
);

const forceUnsupportedBrowserWarning = () => {
  const nextDeprecatedWarningDate = getNextDeprecatedWarningDate();

  return (
    isDeprecatedBrowser &&
    (nextDeprecatedWarningDate === null ||
      new Date(parseInt(nextDeprecatedWarningDate, 10)) <= new Date())
  );
};

export const initialState = {
  isTouchDevice: !!(bowser.mobile || bowser.tablet),
  isSupportedBrowser: bowser.check(
    MIN_SUPPORTED_BROWSERS,
    true,
    window.navigator.userAgent
  ),
  copyUnsupportedBrowser: !bowser.check(
    HTML5_COPY_SUPPORTED_BROWSERS,
    true,
    window.navigator.userAgent
  ),
  isDeprecatedBrowser,
  myBrowser: `${bowser.name} ${bowser.version}`,
  proceedUnsupportedBrowser:
    !forceUnsupportedBrowserWarning() && !!getProceedUnsupportedBrowser(),
  screenWidth: window.innerWidth,
  screenHeight: window.innerHeight,
  breakpoint: getBreakpoint(window.innerWidth)
};

function environment(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ACCOUNT_RECEIVED:
      return {
        ...state,
        proceedUnsupportedBrowser:
          action.data.showBrowserWarnings === false
            ? true
            : initialState.proceedUnsupportedBrowser
      };

    case types.PROCEED_UNSUPPORTED_BROWSER:
      return {
        ...state,
        proceedUnsupportedBrowser: true
      };
    case types.SET_SCREEN_SIZE:
      return {
        ...state,
        screenWidth: action.width,
        screenHeight: action.height,
        breakpoint: getBreakpoint(action.width)
      };
    default:
      return state;
  }
}

export default environment;
